import React from 'react';
import EntityDrawer from '../ui/EntityDrawer';
import AccountDetailContent, { AccountSummary } from './AccountDetailContent';

type AccountDetailDrawerProps = {
  open: boolean;
  onClose: () => void;
  account: AccountSummary | null;
  onAccountUpdated?: () => void;
};

export default function AccountDetailDrawer({
  open,
  onClose,
  account,
  onAccountUpdated,
}: AccountDetailDrawerProps) {
  return (
    <EntityDrawer
      open={open}
      onClose={onClose}
      title={account?.name || 'Account'}
      subtitle={account?.id ? `Account ID: ${account.id}` : undefined}
      widthClassName="max-w-4xl"
    >
      <AccountDetailContent account={account} onAccountUpdated={onAccountUpdated} />
    </EntityDrawer>
  );
}
